/**
 * Cart Grouping Helper
 * Groups cart items to position subscription gifts below their parent subscriptions
 */

/**
 * Groups cart items with proper gift positioning
 * - Threshold/general gifts appear at top
 * - First-time subscriber gifts appear below the first subscription
 * - Product-specific gifts appear directly below their parent subscription
 *
 * @param {Array} items - Cart items array
 * @returns {Array} - Grouped cart items
 */
export function groupCartItems(items) {
  const grouped = []
  const processedGifts = new Set()

  // First, add threshold gifts at the top (maintain current behavior)
  items.forEach(item => {
    if ((item.properties?.isGift === true ||
         item.properties?._isSecondGift === true ||
         item.properties?._isThirdGift === true) &&
        !item.properties?._isProductSpecificGift) {
      grouped.push(item)
      processedGifts.add(item.key)
    }
  })

  // Find the first-time subscriber gift (if any) to insert after first subscription
  const subscriberGift = items.find(item => item.properties?._isSubscriberGift === true)
  let subscriberGiftInserted = false

  // Then add regular items with their subscription gifts
  items.forEach(item => {
    // Skip gifts already processed
    if (item.properties?.isGift ||
        item.properties?._isSecondGift ||
        item.properties?._isThirdGift ||
        item.properties?._isSubscriberGift ||
        item.properties?._isProductSpecificGift) {
      return
    }

    // Add the main item
    grouped.push(item)

    // If this is a subscription and we have a subscriber gift to insert, add it after first subscription
    if (item.selling_plan_allocation && subscriberGift && !subscriberGiftInserted) {
      grouped.push(subscriberGift)
      processedGifts.add(subscriberGift.key)
      subscriberGiftInserted = true
    }

    // If this is a subscription, find and add its product-specific gift
    if (item.selling_plan_allocation) {
      const associatedGift = items.find(giftItem =>
        giftItem.properties?._isProductSpecificGift === true &&
        giftItem.properties?._sourceProductId === item.product_id
      )

      if (associatedGift && !processedGifts.has(associatedGift.key)) {
        grouped.push(associatedGift)
        processedGifts.add(associatedGift.key)
      }
    }
  })

  return grouped
}
